/**
 * PURPOSE: Resolver la compañía efectiva de la pestaña a partir de ?idcompany= (FTR-0012).
 * RESPONSIBILITIES: Validar el id de la URL contra las compañías administrables del actor y decidir
 *   entre listo, inválido, redirección (única compañía o última elegida) o selección explícita.
 *   Una selección inválida nunca produce compañía efectiva, así no se emiten requests privilegiados.
 * COLLABORATORS: src/hooks/useEffectiveCompany.js, src/services/effectiveCompanyContext.js.
 * ROUTE: winscore/src/hooks/effectiveCompany.utils.js
 */
import { parseCompanyId } from "../services/effectiveCompanyContext.js";

export const LAST_COMPANY_STORAGE_KEY = "winscore.lastCompanyId";

const hasRawValue = (value) => value !== null && value !== undefined && String(value) !== "";

export const resolveEffectiveCompanySelection = ({
  urlCompanyId,
  allowedCompanyIds = [],
  rememberedCompanyId = null,
}) => {
  const allowed = [...new Set(allowedCompanyIds.map(parseCompanyId).filter(Boolean))];

  if (allowed.length === 0) {
    return { status: "empty", effectiveCompanyId: null, redirectCompanyId: null };
  }

  if (hasRawValue(urlCompanyId)) {
    const fromUrl = parseCompanyId(String(urlCompanyId));
    return fromUrl && allowed.includes(fromUrl)
      ? { status: "ready", effectiveCompanyId: fromUrl, redirectCompanyId: null }
      : { status: "invalid", effectiveCompanyId: null, redirectCompanyId: null };
  }

  if (allowed.length === 1) {
    return { status: "redirect", effectiveCompanyId: null, redirectCompanyId: allowed[0] };
  }

  const remembered = parseCompanyId(hasRawValue(rememberedCompanyId) ? String(rememberedCompanyId) : null);
  if (remembered && allowed.includes(remembered)) {
    return { status: "redirect", effectiveCompanyId: null, redirectCompanyId: remembered };
  }

  return { status: "select", effectiveCompanyId: null, redirectCompanyId: null };
};
